/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The SignUpResponse model module.
 * @module model/SignUpResponse
 * @version v1
 */
export class SignUpResponse {
  /**
   * Constructs a new <code>SignUpResponse</code>.
   * @alias module:model/SignUpResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SignUpResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SignUpResponse} obj Optional instance to populate.
   * @return {module:model/SignUpResponse} The populated <code>SignUpResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SignUpResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('account'))
        obj.account = ApiClient.convertToType(data['account'], Object);
      if (data.hasOwnProperty('messages'))
        obj.messages = ApiClient.convertToType(data['messages'], Object);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
SignUpResponse.prototype.status = undefined;

/**
 * @member {Object} account
 */
SignUpResponse.prototype.account = undefined;

/**
 * @member {Object} messages
 */
SignUpResponse.prototype.messages = undefined;

